export default __webpack_public_path__ + "static/media/pink beanie.1363ada6.png";